import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trend-chart',
  templateUrl: './trend-chart.component.html',
  styleUrls: ['./trend-chart.component.scss']
})
export class TrendChartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
